"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
const flatpickr_1 = __importDefault(require("flatpickr"));
class default_1 extends stimulus_1.Controller {
    connect() {
        let flatpickerOptions = Object.assign({
            minDate: "today",
            monthSelectorType: "static",
            inline: true,
            altInput: false,
            allowInput: false,
            disableMobile: true,
            altFormat: "l, F j, Y",
            dateFormat: "Y-m-d",
            // enable: [],
            // onMonthChange(selectedDates, value, instance, data) {
            //   console.log(instance);
            // },
        }, this.optionsValue);
        (0, flatpickr_1.default)(this.element, flatpickerOptions);
        //this.element.removeAttribute("readonly");
    }
}
exports.default = default_1;
default_1.values = {
    options: Object,
};
